import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { lightGreen } from '@mui/material/colors';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Link } from 'react-router-dom';

import { PrefilledAccessPointButtons } from '../PrefilledAccessPointButtons/PrefilledAccessPointButtons';

export const DevelopmentButtons = () => (
    <Box mt={2}>
        <Card style={{ background: lightGreen[50] }}>
            <CardContent>
                <Typography variant="h6">These buttons are for development purposes only.</Typography>

                <Box my={2}>
                    <PrefilledAccessPointButtons />
                </Box>

                <Typography variant="body2" component="span">
                    Quick links
                    <List component="nav" aria-label="list of links">
                        <ListItem>
                            <Link to="/checkaccess">Link to check access page</Link>
                        </ListItem>
                        <ListItem>
                            <Link to="/accesspoint/YCA01=PM15">Link to access point page</Link>
                        </ListItem>
                        <ListItem>
                            <Link to="/accesspoint/YCA01=PM15/permissions/LHC-TNL">Link to permission page</Link>
                        </ListItem>
                        <ListItem>
                            <Link to="/accesspoint/YCA01=PM15/permissions/LHC-TNL/permits">Link to permits page</Link>
                        </ListItem>
                    </List>
                </Typography>
            </CardContent>
        </Card>
    </Box>
);
